<template>
  <div class="flex items-center mt-4">
    <div class="background-icon p-2 rounded mr-2">
      <MIcon name="tags" size="lg" class="text-neutral-light" />
    </div>
    <ApprovalStatusIcon
      v-if="value.approvalStatus"
      class="cursor-text flex mx-1"
      :status="value.approvalStatus"
    >
      <template v-slot:prefix-text> {{ $tc('approval') }}: </template>
    </ApprovalStatusIcon>
    <MTag
      v-if="isApproval"
      :closable="false"
      :confirmable="false"
      class="cursor-text mx-1"
      style="background-color: var(--page-background-color);"
    >
      {{ $tc('approval') }} {{ $tc('requester') }} :
      <FlotoUserDrawer :user-id="approval.createdById" />
    </MTag>
    <FlotoTagsPicker
      :value="value.tags"
      :confirm-before-remove="true"
      variant="neutral-lighter"
      :disabled="disabled"
      @change="handleChange({ tags: $event })"
    />
  </div>
</template>

<script>
import ApprovalStatusIcon from '@components/approval/components/approval-status-icon'

export default {
  name: 'TagsRow',
  components: { ApprovalStatusIcon },
  model: {
    event: 'change',
  },
  props: {
    value: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    resource: { type: Object, required: true },
    isApproval: { type: Boolean, default: false },
    approval: { type: Object, default: undefined },
    moduleName: { type: String, required: true },
  },
  methods: {
    handleChange(change) {
      this.$emit('change', change)
    },
  },
}
</script>
